import { AssignmentTurnedIn, BugReport, Logout, VerifiedUser, Payment, Receipt } from '@mui/icons-material';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import dashSvg from 'assets/images/drawer/dashboard.svg';
import gameListSvg from 'assets/images/drawer/games.svg';
import guideSvg from 'assets/images/drawer/guide.svg';
import settingSvg from 'assets/images/drawer/setting.svg';
import userSvg from 'assets/images/drawer/user-mgt.svg';
import walletSvg from 'assets/images/drawer/wallet.svg';
import agentSvg from '../assets/images/app/agent.svg';

export const mainConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: dashSvg,
  },
  // {
  //   title: 'User Management',
  //   path: '/user-management',
  //   icon: userSvg,
  // },
  {
    title: 'Player Management',
    path: '/player-management',
    icon: userSvg,
  },
  {
    title: 'Agent Management',
    path: '/agent-management',
    icon: agentSvg,
  },
  {
    title: 'Wallet Information',
    path: '/wallet-information',
    icon: walletSvg,
  },
  {
    title: 'Payout Review',
    path: '/payout-review',
    icon: <AssignmentTurnedIn />,
    type: 'mui',
  },
  {
    title: 'Kyc',
    path: '/kyc',
    icon: <VerifiedUser />,
    type: 'mui',
  },
  {
    title: 'Issues Management',
    path: '/issues-management',
    icon: <BugReport />,
    type: 'mui',
  },
  {
    title: 'Games',
    path: '/game-list',
    icon: gameListSvg,
  },
  {
    title: 'Payment Methods',
    path: '/payment-methods',
    icon: <Payment />,
    type: 'mui',
  },

  {
    title: 'Guidelines',
    path: '/guideline',
    icon: guideSvg,
  },
  {
    title: 'Banner',
    path: '/banners',
    icon: guideSvg,
  },
  {
    title: 'Settings',
    path: '/settings',
    icon: settingSvg,
  },
  {
    title: 'App Version',
    path: '/app-version',
    icon: <DeveloperModeIcon />,
    type: 'mui',
  },
  {
    title: 'logout',
    path: '/logout',
    icon: <Logout />,
    type: 'mui',
  },
];

export const agentConfig = [
  {
    title: 'Dashboard',
    path: '/agent/dashboard',
    icon: dashSvg,
  },
  {
    title: 'Players',
    path: '/agent/players',
    icon: userSvg,
  },
  {
    title: 'Players Transaction',
    path: '/agent/players-transaction',
    icon: agentSvg,
  },
  {
    title: 'Withrawal Request',
    path: '/agent/withdrawal-request',
    icon: walletSvg,
  },
  {
    title: 'Earnings',
    path: '/agent/earnings',
    icon: walletSvg,
  },
  {
    title: 'Agent Transaction',
    path: '/agent/agent-transaction',
    icon: agentSvg,
  },
  {
    title: 'Payment Tickets',
    path: '/agent/payment-tickets',
    icon: <Receipt />,
    type: 'mui',
  },
  {
    title: 'Guidelines',
    path: '/agent/guideline',
    icon: guideSvg,
  },
  {
    title: 'Settings',
    path: '/settings',
    icon: settingSvg,
  },
  {
    title: 'logout',
    path: '/logout',
    icon: <Logout />,
    type: 'mui',
  },
];

export const otherConfig = [
  {
    title: 'Settings',
    path: '/settings',
    icon: settingSvg,
  },
];
